import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { CloseDialog, OpenDialog, OpenUrl } from './error.actions';
import { patch } from '@ngxs/store/operators';
import { openWindow } from 'src/app/_core/utils/open-window';

export type ErrorStateModel = {
  url: string;
  content: string;
  open: boolean;
};

export const initialState: ErrorStateModel = {
  url: '',
  content: '',
  open: false,
};

@State<ErrorStateModel>({
  name: 'errorDialog',
  defaults: initialState,
})
@Injectable()
export class ErrorDialogState {

  @Selector()
  static open(state: ErrorStateModel): boolean {
    return state.open;
  }

  @Selector()
  static url(state: ErrorStateModel): string {
    return state.url;
  }

  @Selector()
  static content(state: ErrorStateModel): string {
    return state.content;
  }

  @Action(OpenDialog)
  openDialog(context: StateContext<ErrorStateModel>, { url, content }: OpenDialog) {
    context.setState(
      patch({
        open: true,
        url,
        content,
      }),
    );
  }

  @Action(CloseDialog)
  closeDialog(context: StateContext<ErrorStateModel>) {
    context.setState(
      patch({
        open: false,
        url: '',
        content: '',
      }),
    );
  }

  @Action(OpenUrl)
  openUrl(context: StateContext<ErrorStateModel>) {
    openWindow(context.getState().url);
  }
}
